import { ProjectManagementState } from '@/store/ProjectManagement/ProjectManagementRoot';
import { ActionTree } from 'vuex';

// API
import {
    getChartVersionStructure,
    getPMChart,
    getUsersStructure,
    updatePMChart,
} from '@/utils/api/ProjectManagement/PMChart';

import { keeper } from '@/plugins/PromiseKeeper/PromiseKeeper';
import { IPMChart } from '@/ship/Models/IProjectManagement';
import PMChartEditModel from '@/ship/Models/PMChartEditModel';
import { ChartVersion } from '@/ship/Models/ProjectManagement';
import User from '@/ship/Models/User';
import { GetRequestParams } from '@/ship/Requests/RequestParams';

export const actions: ActionTree<ProjectManagementState, ProjectManagementState> = {
    async getChartById({ state, commit }, payload: { id: number; params?: GetRequestParams }): Promise<IPMChart> {
        if (state.chart && state.chart.id == payload.id) return state.chart;

        return keeper.get('getChartById', async () => {
            const {
                data: { data: chart },
            } = await getPMChart(payload.id, payload.params);

            commit('setChart', chart);

            return chart;
        });
    },

    async UPDATE_CHART_BY_ID({ state, commit }, payload: { id: number; data: PMChartEditModel }): Promise<IPMChart> {
        return keeper.get('UPDATE_CHART_BY_ID', async () => {
            const {
                data: { data: chart },
            } = await updatePMChart(payload.id, payload.data);

            commit('UPDATE_CHART_BY_ID', chart);

            return chart;
        });
    },

    /**
     *
     * @param param0
     * @param id
     * @param isStrict - подразумевает, что можно обходить проверку и при необходимости перезаписывать состояние
     * @returns
     */
    async getChartVersionById({ state, commit }, id: number, isStrict = true): Promise<ChartVersion> {
        if (state.chartVersion && state.chartVersion.id == id && isStrict) return state.chartVersion;
        return keeper.get('getChartVersionById', async () => {
            const {
                data: { data: chartVersion },
            } = await getChartVersionStructure(id);

            commit('setChartVersion', chartVersion);

            return chartVersion;
        });
    },

    async getUsers({ commit }): Promise<User[]> {
        return keeper.get('getUsers', async () => {
            const {
                data: { data: users },
            } = await getUsersStructure();

            commit('setUsers', users);

            return users;
        });
    },
};
export default actions;
